define('score_bootstrap/Models/Search/FacetRatingsPanel',[
    "jquery",
    "knockout"    
], function ($, ko) {
    "use strict";

    var searchLogic = [ "and", "or" ];

    function FacetRatingsPanel(panelElement, allPreselected) {
        var $dataEl = $(".js-facet", panelElement),
            title = $dataEl.attr("data-title"),
            indexFieldName = $dataEl.attr("data-index-field-name"),
            searchLogicType = $dataEl.attr("data-search-logic-type").toLowerCase(),
            id = $dataEl.attr("data-id");

        var preselected = allPreselected && allPreselected[title] ? allPreselected[title][0] : null;

        this.currentRatingValue = ko.observable(preselected);

        Object.defineProperties(this, {
            id: {
                value: id
            },
            title: {
                value: title
            },
            searchLogicType: {
                value: searchLogic.indexOf(searchLogicType)
            },
            rating: {
                get: function() {
                    return this.currentRatingValue() && this.currentRatingValue() !== "0" ? this.currentRatingValue() : null;
                }
            },
            indexFieldName: {
                get: function() {
                    return indexFieldName;
                }
            },
            asString: {
                get: function () {
                    return this.currentRatingValue() && this.currentRatingValue() !== "0" ? this.title + ":" + this.currentRatingValue() : null;
                }
            }
        });

        this.selectValues = function (selectedValues) {
            var newValue = selectedValues && selectedValues[title] ? selectedValues[title][0] : null;
            var oldValue = this.currentRatingValue();
            if (oldValue !== newValue) {
                this.currentRatingValue(newValue);
            }
        };

        this.unselectAll = function unselectAll() {
            this.currentRatingValue("0");
        };

        ko.applyBindings(this, panelElement);
    }

    return FacetRatingsPanel;
});
